import { MenuIds, useMenus } from "./useMenus";

export function useIsTextEditMode() {
	const { menuId } = useMenus();

	return menuId === MenuIds.TextValue;
}
